import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -10","key":"svg-0"}],["path",{"d":"M6 5v-2","key":"svg-1"}],["path",{"d":"M18 3v2","key":"svg-2"}],["path",{"d":"M6.5 12h3","key":"svg-3"}],["path",{"d":"M14.5 12h3","key":"svg-4"}],["path",{"d":"M16 10.5v3","key":"svg-5"}]]

const IconBatteryAutomotive = createReactComponent('outline', 'battery-automotive', 'BatteryAutomotive', __iconNode);

export default IconBatteryAutomotive;